import { NgModule } from "@angular/core";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzStepsModule } from "ng-zorro-antd/steps";

@NgModule({
  imports: [NzButtonModule, NzStepsModule],
  exports: [NzButtonModule, NzStepsModule],
})
export class NgZorroAntdModule {}
